import store from "@/store/index";
import { refresh } from "@/api/auth";

let isTokenRefreshing = false;
let refreshSubscribers = [];

// 리프레시 후, 대기 중인 요청을 재시도하기 위한 콜백 실행
const onTokenRefreshed = (newToken) => {
  refreshSubscribers.forEach((callback) => callback(newToken));
  refreshSubscribers = [];
};

// 토큰 갱신이 완료되면 재시도할 요청을 등록
const addRefreshSubscriber = (callback) => {
  refreshSubscribers.push(callback);
};

export function setAuthInterceptors(instance) {
  instance.interceptors.request.use(
    (config) => {
      const ndbTkn = store.getters["userStore/getNdbTkn"];
      if (ndbTkn) {
        config.headers.Authorization = `Bearer ${ndbTkn}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const { config, response } = error;
      if (!response) return Promise.reject(error); // 네트워크 오류 대비

      const originalRequest = config;
      const { status, data } = response;

      // AccessToken 만료 (A003)
      if (status === 401 && data.code === "A003") {
        return new Promise((resolve, reject) => {
          // 실패한 요청을 큐에 저장 (첫 번째 요청도 포함)
          addRefreshSubscriber((newToken) => {
            originalRequest.headers.Authorization = `Bearer ${newToken}`;
            resolve(instance({
              ...originalRequest, 
              skipLoading: originalRequest.skipLoading === true //refresh 이후 기존 config값이 유실되어 추가
            }));
          });

          // 토큰 갱신 진행중이 아니면 갱신 시작
          if (!isTokenRefreshing) {
            isTokenRefreshing = true;
            const orginTkn = store.getters["userStore/getNdbTkn"];
            const param = { ndbTkn: orginTkn };
            refresh(param)
              .then((renewToken) => {
                store.dispatch("userStore/REFRESH_USER", renewToken.data);
                isTokenRefreshing = false; // 다음 갱신을 위해 먼저 해제
                onTokenRefreshed(renewToken.data.data.ndbTkn); // 큐에 있는 요청들 재시도
              })
              .catch((refreshError) => {
                // 실패해도 반드시 해제. 안 풀면 이후 401에서 refresh가 영영 안 나감
                // (기존 .finally는 아래 영구 pending 프로미스 뒤에 체이닝돼 실행되지 않았음)
                isTokenRefreshing = false;
                refreshSubscribers = []; // 큐 초기화
                store.commit("uiStore/RESET_LOADING");
                store.dispatch("userStore/LOGOUT", { reason: "expired" });

                //인증 에러인 경우(401) catch절로 떨어지지 않게 처리
                return new Promise(() => { });
              });
          }
        });
      }
      // RefreshToken 만료 (A004)
      else if (status === 401 && data.code === "A004") {
        store.commit("uiStore/RESET_LOADING");
        store.dispatch("userStore/LOGOUT", { reason: "expired" });
        //인증 에러인 경우(401) catch절로 떨어지지 않게 처리
        return new Promise(() => { });
      }

      return Promise.reject(error);
    }
  );

  return instance;
}